<template>
  <div class="content">
    <div class="row">
      <div class="col-md-4">
        <div class="card card-user">
          <div class="image">
            <img src="../assets/img/bg/damir-bosnjak.jpg" alt="...">
          </div>
          <div class="card-body">
            <div class="author">
              <a href="#">
                <!--<img v-if="typeof user.photo == 'undefined' && !user.photo" :src="user.photo" class="avatar border-gray" style="width: 135px !important;"/>
                <img v-else src="../assets/img/logo-small.png" class="avatar border-gray" style="width: 135px !important;"/>-->
                <img :src="$store.getters.getProfilePhoto" class="avatar border-gray" style="width: 135px !important;"/>
                <h5 class="title">{{ user.name }}</h5>
              </a>
            </div>
            <p class="description text-center">
              "I like the way you work it
              <br> No diggity
              <br> I wanna bag it up"
            </p>
          </div>
        </div>
        <!--<div class="card">
          <div class="card-header">
            <h4 class="card-title">Team Members</h4>
          </div>
          <div class="card-body">
            <ul class="list-unstyled team-members">
              <li>
                <div class="row">
                  <div class="col-md-2 col-2">
                    <div class="avatar">
                      <img src="../assets/img/faces/ayo-ogunseinde-2.jpg" alt="Circle Image" class="img-circle img-no-padding img-responsive">
                    </div>
                  </div>
                  <div class="col-md-7 col-7">
                    DJ Khaled
                    <br>
                    <span class="text-muted">
                          <small>Offline</small>
                        </span>
                  </div>
                  <div class="col-md-3 col-3 text-right">
                  </div>
                </div>
              </li>
              <li>
                <div class="row">
                  <div class="col-md-2 col-2">
                    <div class="avatar">
                      <img src="../assets/img/faces/joe-gardner-2.jpg" alt="Circle Image" class="img-circle img-no-padding img-responsive">
                    </div>
                  </div>
                  <div class="col-md-7 col-7">
                    Creative Tim
                    <br>
                    <span class="text-success">
                          <small>Available</small>
                        </span>
                  </div>
                  <div class="col-md-3 col-3 text-right">
                  </div>
                </div>
              </li>
              <li>
                <div class="row">
                  <div class="col-md-2 col-2">
                    <div class="avatar">
                      <img src="../assets/img/faces/clem-onojeghuo-2.jpg" alt="Circle Image" class="img-circle img-no-padding img-responsive">
                    </div>
                  </div>
                  <div class="col-ms-7 col-7">
                    Flume
                    <br>
                    <span class="text-danger">
                          <small>Busy</small>
                        </span>
                  </div>
                  <div class="col-md-3 col-3 text-right">
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>-->
      </div>
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">
            <h5 class="title">{{ $t('label.edit-profile')}}</h5>
          </div>
          <div class="card-body">
            <form>
              <div class="row">
                <div class="col-md-5 pr-1">
                  <div class="form-group">
                    <label>{{ $t('label.company')}}</label>
                    <input type="text" class="form-control" disabled="" placeholder="Company" v-model="user.organization">
                  </div>
                </div>
                <div class="col-md-3 px-1">
                  <div class="form-group">
                    <label>{{ $t('label.username')}}</label>
                    <input type="text" class="form-control" placeholder="Username" v-model="user.login">
                  </div>
                </div>
                <div class="col-md-4 pl-1">
                  <div class="form-group">
                    <label for="exampleInputEmail1">{{ $t('label.email')}}</label>
                    <input type="email" class="form-control" placeholder="Email" v-model="user.email">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5 pr-1">
                  <div class="form-group">
                    <label>{{ $t('label.name')}}</label>
                    <input type="text" class="form-control" placeholder="Company" v-model="user.name">
                  </div>
                </div>
                <div class="col-md-3 px-1">
                  <div class="form-group">
                    <label>{{ $t('label.mobile-phone')}}</label>
                    <input type="text" class="form-control" placeholder="Mobile Phone" v-model="user.tel">
                  </div>
                </div>
                <div class="col-md-4 pl-1">
                  <div class="form-group">
                    <label>{{ $t('label.front-office')}}</label>
                    <input type="text" class="form-control" placeholder="City" v-model="user.frontOffice" disabled="">
                  </div>
                </div>
              </div>
            </form>
            <div class="d-flex flex-row-reverse">
              <button class="btn btn-info" @click="saveProfile">{{ $t('button.save')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loader :is-visible="isLoading"></loader>

  </div>
</template>

<script>
  import Loader from '../components/Loader.vue';

  export default {
    name: "Profile",
    components: {
      Loader,
    },
    data() {
      return {
        user:{
          login:'',
          name:'',
          email:'',
          tel:'',
          organization:'',
          frontOffice:'',
          photo:''
        },
        isLoading: false,
        }
      },
    mounted() {
      this.getDataProfile();
    },
    methods: {
      getDataProfile() {
        this.isLoading = true;
        axios
            .post("/drawing/getDataProfile", {
              session: localStorage.getItem('user-token')
            })
            .then(res => {
                this.user.login        = res.data.login;
                this.user.name         = res.data.name;
                this.user.email        = res.data.email;
                this.user.tel          = res.data.tel;
                this.user.organization = res.data.organization;
                this.user.frontOffice  = res.data.frontOffice;
                this.user.photo = "data:image/png;base64," + localStorage.getItem('image');
                this.isLoading = false;
            })
            .catch(e => {
              this.isLoading = false;
              this.showNotify("error", "Save", "Помилка авторизації " + e);
            });
      },

      saveProfile(){
        this.isLoading = true;
        axios
          .post("/drawing/saveProfile", {
            session: localStorage.getItem('user-token'),
            user: this.user
          })
          .then(res => {
            this.isLoading = false;
            this.showNotify("success", "Save", "Дані збережено");
          })
          .catch(e => {
            this.isLoading = false;
            this.showNotify("error", "Save", "Помилка збереженя " + e);
          });

      },

      showNotify(group, title, messages){
        this.$notify({
          group: group,
          title: title,
          text: messages
        });
      }
      
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue